import { AnyAction } from 'redux';
import {
  VIPPS_ERROR_RECEIVED,
  VIPPS_ERROR_RESET
} from '../constants';


export interface VippsErrorState {
    vippsError: string | null;
}

const DEFAULT_STATE = {
    vippsError: null
};

export const vippsError = (state = DEFAULT_STATE, action: AnyAction): VippsErrorState => {
  switch (action.type) {
    case VIPPS_ERROR_RECEIVED:
       return {
        ...state,
        vippsError: action.payload,
      };
    case VIPPS_ERROR_RESET:
      return {
        vippsError: null
      };
    default:
      return state;
  }
};